import { render, staticRenderFns } from "./ResourceLib.vue?vue&type=template&id=75d2801a&scoped=true"
import script from "./ResourceLib.vue?vue&type=script&lang=js"
export * from "./ResourceLib.vue?vue&type=script&lang=js"
import style0 from "./ResourceLib.vue?vue&type=style&index=0&id=75d2801a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d2801a",
  null
  
)

export default component.exports